import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import { PriceDisplayStyled } from './PriceDisplayStyled';
import { jsx as _jsx } from "react/jsx-runtime";
const calculatedPriceSubTermWithPriceBreakdownForFree = {
  fullPrice: 0,
  calculatedPrice: 0
};
const quantityPackPurchaseOptionForFree = {
  monthly: calculatedPriceSubTermWithPriceBreakdownForFree,
  annually: calculatedPriceSubTermWithPriceBreakdownForFree,
  offerInfo: {
    commitment: 'monthly',
    payment: 'monthly',
    discount: 0
  }
};
const FreePriceDisplayStyled = () => {
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  return /*#__PURE__*/_jsx(PriceDisplayStyled, {
    pricingInfo: quantityPackPurchaseOptionForFree,
    showPricePerMonthPerSeat: false,
    seleniumId: "free-price-per-month",
    currencyCode: currencyCode,
    currencyCodeUnit: currencyCodeUnit
  });
};
export default FreePriceDisplayStyled;